import { useLocation, useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import React, { useEffect } from "react";

export default function JobApplicationRedirectPage() {
  const { search } = useLocation();
  const jobId = new URLSearchParams(search).get("job-id");

  const history = useHistory();

  console.log({ jobId });

  useEffect(() => {
    history.push(`/jobs/${jobId}/apply`);
  }, [jobId]);

  return <div>Redirecting...</div>;
}